// AccessDenied Component
import React from 'react';

const AccessDenied = () => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px', maxWidth: '400px', margin: 'auto' }}>
        <h1 style={{ fontSize: '2em', marginBottom: '10px' }}>Access Denied</h1>
        <p style={{ color: "black", fontSize: '1em', padding: '20px', }}>
        We're sorry, but you do not have the necessary permissions to access this page. If you believe this is an error, please contact the administrator for assistance.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
